// extracted by mini-css-extract-plugin
module.exports = {"horizontalDivider":"styles_horizontalDivider__CpGcY"};